import './App.css';
import React from 'react';
import Login from './components/Login';
import ForgetPassword from './components/ForgetPassword';
import SignUp from './components/SignUp';
import Dashboard from './components/Dashboard';
import DashboardCharts from './components/DashboardCharts';
import Sequence from './components/squence/Sequence';
import SequenceList from './components/squence/AllSquence';
import Platform from './components/squence/Platform';
import SelectedLead from './components/squence/SelectedLead';
import LeadList from './components/LeadList';
import Account from './components/Account';
import UserDetail from './components/UserDetail';
import Opportunities from './components/opportunities';
import SequenceReport from './components/squence/SequenceReport'
import Plans from './components/Plans';
import Billing from './components/Billing';
import Invoice from './components/Invoice';
import SequenceBreakdown from './components/SequenceBreakdown';
import SequenceDetail from './components/SequenceDetail';
import Mapping from './components/mapping';

import {
  BrowserRouter,
  Routes, //replaces "Switch" used till v5
  Route,
} from "react-router-dom";

function App(props) {

  const isLoggedIn = localStorage.getItem('isLoggedIn');

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard-charts" element={<DashboardCharts />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/sequence" element={<Sequence />} />
          <Route path="/sequence-list" element={<SequenceList />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/selected-lead" element={<SelectedLead />} />
          <Route path="/lead-list" element={<LeadList />} />
          <Route path="/account" element={<Account />} />
          <Route path="/user-detail" element={<UserDetail />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/sequence-report" element={<SequenceReport />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/sequencebreakdown" element={<SequenceBreakdown />} />
          <Route path="/mapping" element={<Mapping />} />
          <Route path="/sequence-detail" element={<SequenceDetail />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
